export default __webpack_public_path__ + "static/media/Mcdonalds.a0fba246.png";